import React, { useEffect, useState, useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import { Link, useParams, withRouter, useHistory } from "react-router-dom";
import
{
    CardBody,
    Container,
    Row,
    Card,
    CardHeader,
    Spinner,
    Alert,
    Col,
    Modal,
    Form,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Input,
} from "reactstrap";


// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//Import Breadcrumb
import BreadCrumb from "../../../../Components/Common/BreadCrumb";

import TableContainer from "../../../../Components/Common/TableContainer";
//Import actions
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withTranslation } from "react-i18next";
import axiosInstance from "../../../../axiosConfig";
import TakciLogo from "../../../../assets/images/logo-light.png";

//redux
import { useDispatch } from "react-redux";

import Loader from "../../../../Components/Common/Loader";
import Key from "../../../../key";
import InfosEvent from "../../../../Components/Common/InfosEvent";


import moment from "moment";
import "moment/locale/fr";


moment.locale( "fr" );

const UpdateTicketModal = ( { ticket, setTicket, loadingSaveBillet, setLoadingSaveBillet, modalUpdateTicket, setModalUpdateTicket, setLoadingTicket, fetchEventTicketData } ) =>
{
    const { id: eventId } = useParams();

    useEffect( () =>
    {
        console.log( "ticket UpdateTicketModal: ", ticket )
    }, [ ticket ] )
    // validationTicketUpdate
    const validationTicketUpdate = useFormik( {
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            categorie: ticket.categorie || "",
            quantite: ticket.quantite || "",
            montant: ticket.montant || "",
            color_billet: ticket.color_billet || "",
        },
        validationTicketUpdateSchema: Yup.object( {
            categorie: Yup.string().required(
                ( "Veuillez renseigner la catégorie" )
            ),
            quantite: Yup.number()
                .min( 1, "La quantite ne peut pas être inférieur à 0" )
                .required(
                    ( "Veuillez renseigner la quantite" )
                ),
            montant: Yup.number()
                .min( 100, "Le montant ne peut pas être inférieur à 100" )
                .required(
                    ( "Veuillez renseigner le montant" )
                ),
            color_billet: Yup.string().required(
                ( "Veuillez renseigner la catégorie" )
            ),

        } ),
        onSubmit: ( values ) =>
        {
            setLoadingSaveBillet( true );

            const dataTicketUpdate = {
                ...values,
                billet_id: ticket.id,
            }

            try
            {
                const data = axiosInstance.post( `/billetupdate/`, dataTicketUpdate ).then(
                    ( response ) =>
                    {
                        if ( response )
                        {
                            validationTicketUpdate.resetForm();
                            toast.success( ( "Ticket modifié avec succès" ), {
                                autoClose: 3000,
                            } );
                            setLoadingTicket( true );
                            fetchEventTicketData();
                        } else
                        {
                            console.error( "Echec de la modification du ticket." );
                            toast.error( ( "Une erreur s'est produite lors de la modification du ticket" ), {
                                autoClose: 3000,
                            } );
                        }
                    } ).catch(
                        ( error ) =>
                        {
                            console.error( "Echec de la modification du ticket. Erreur: ", error );
                            toast.error( ( "Echec de la modification du ticket" ), {
                                autoClose: 3000,
                            } );
                        }
                    );

            } catch ( err )
            {
                console.error( err );
                toast.error( ( "Echec de la modification du ticket" ), {
                    autoClose: 2000,
                } );
            }

            setTicket( {} );
            setModalUpdateTicket( false );
            setLoadingSaveBillet( false );
        },

    } );

    document.title = ( "Détails de l'evénement | Takci" );

    return (
        <Modal
            id="showModal"
            style={ { maxWidth: 800 } }
            isOpen={ modalUpdateTicket }
            centered
        >
            <ModalHeader className="bg-soft-info p-3">
                Modifier le ticket
            </ModalHeader>

            <Form
                onSubmit={ ( e ) =>
                {
                    e.preventDefault();
                    validationTicketUpdate.handleSubmit();
                    return false;
                } }
            >
                <ModalBody>
                    <Row className="g-2 justify-content-end">
                        <Col md={ 6 } lg={ 4 } xxl={ 4 }>
                            <label htmlFor={ `categorie` } className="form-label fs-7">
                                Catégorie du billet :
                            </label>
                            <Input
                                type="text"
                                id={ `categorie` }
                                name={ `categorie` }
                                placeholder={ `Nom de catégorie` }
                                className="form-control"
                                validate={ {
                                    required: { value: true },
                                } }
                                onChange={ validationTicketUpdate.handleChange }
                                onBlur={ validationTicketUpdate.handleBlur }
                                value={ validationTicketUpdate.values.categorie }
                                invalid={
                                    validationTicketUpdate.touched.categorie &&
                                        validationTicketUpdate.errors.categorie
                                        ? true
                                        : false
                                }
                            />
                        </Col>
                        <Col md={ 6 } lg={ 4 } xxl={ 4 }>
                            <label htmlFor={ `quantite` } className="form-label fs-7">
                                Quantité :
                            </label>
                            <Input
                                type="number"
                                min="1"
                                id={ `quantite` }
                                name={ `quantite` }
                                required
                                className="form-control"
                                placeholder={ `Quantité du ticket` }
                                validate={ {
                                    required: { value: true },
                                } }
                                onChange={ validationTicketUpdate.handleChange }
                                onBlur={ validationTicketUpdate.handleBlur }
                                value={ validationTicketUpdate.values.quantite }
                                invalid={
                                    validationTicketUpdate.touched.quantite &&
                                        validationTicketUpdate.errors.quantite
                                        ? true
                                        : false
                                }
                            />
                        </Col>
                        <Col md={ 6 } lg={ 4 } xxl={ 4 }>
                            <label htmlFor={ `montant` } className="form-label fs-7">
                                Montant :
                            </label>
                            <Input
                                type="number"
                                min="100"
                                id={ `montant` }
                                name={ `montant` }
                                required
                                className="form-control"
                                placeholder={ `Montant du ticket` }
                                validate={ {
                                    required: { value: true },
                                } }
                                onChange={ validationTicketUpdate.handleChange }
                                onBlur={ validationTicketUpdate.handleBlur }
                                value={ validationTicketUpdate.values.montant }
                                invalid={
                                    validationTicketUpdate.touched.montant &&
                                        validationTicketUpdate.errors.montant
                                        ? true
                                        : false
                                }
                            />
                        </Col>
                        <Col md={ 6 } lg={ 4 } xxl={ 3 }>
                            <label htmlFor={ `color_billet` } className="form-label fs-7">
                                Couleur du Billet :
                            </label>
                            <Input
                                type="color"
                                id={ `color_billet` }
                                name={ `color_billet` }
                                required
                                className="form-control"
                                onChange={ validationTicketUpdate.handleChange }
                                onBlur={ validationTicketUpdate.handleBlur }
                                value={ validationTicketUpdate.values.color_billet }
                                invalid={
                                    validationTicketUpdate.touched.color_billet &&
                                        validationTicketUpdate.errors.color_billet
                                        ? true
                                        : false
                                }
                            />
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <div className="hstack gap-2 justify-content-end">
                        <Button
                            type="button"
                            onClick={ () =>
                            {
                                setModalUpdateTicket( false );
                            } }
                            className="btn-light"
                        >
                            { ( "Fermer" ) }
                        </Button>

                        {/* <button type="button" className="btn btn-light" onClick={() => { setModal(false);dispatch(onGetCodePromos); }} > {("Fermer")} </button> */ }
                        <Button
                            disabled={ loadingSaveBillet }
                            type="submit"
                            className="btn"
                            style={ { background: "#002437", color: "white" } }
                            id="add-btn"
                        >
                            {
                                loadingSaveBillet ? <>
                                    <div className="d-flex text-center">
                                        <Spinner size={ "sm" } />
                                        <span className="ms-1">Modification...</span>
                                    </div>
                                </> :
                                    <span>
                                        Modifier le ticket
                                    </span>
                            }
                        </Button>
                    </div>
                </ModalFooter>
            </Form>
        </Modal>
    );
};


export default UpdateTicketModal;
